export function UserDetailHeader({ user, onDisable, onEnable, onAddPermission, statusSaving, c, dark, A }) {
  const isActive = user?.status === "active";

  return (
    <div
      style={{
        borderBottom: `1px solid ${c.cardBdr}`,
        padding: "14px 18px",
        background: c.sb,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexShrink: 0,
      }}
    >
      <div>
        <p
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: ".08em",
            textTransform: "uppercase",
            color: c.sub,
            margin: 0,
            marginBottom: 3,
          }}
        >
          Overview
        </p>
        <p style={{ fontSize: 15, fontWeight: 700, color: c.text, margin: 0 }}>User Details</p>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
          <button
            type="button"
            onClick={isActive ? onDisable : onEnable}
            disabled={statusSaving}
            style={{
              border: "1px solid #ef444480",
              color: "#ef4444",
              background: dark ? "rgba(239,68,68,.14)" : "#fff",
              borderRadius: 8,
              height: 32,
              padding: "0 12px",
              fontSize: 12,
              fontWeight: 600,
              cursor: statusSaving ? "wait" : "pointer",
              opacity: statusSaving ? 0.7 : 1,
            }}
          >
            {isActive ? "Disable user" : "Enable user"}
          </button>
          <button
            type="button"
            onClick={onAddPermission}
            style={{
              height: 32,
              borderRadius: 8,
              border: "none",
              background: A,
              color: "#fff",
              fontSize: 12,
              fontWeight: 600,
              padding: "0 12px",
              cursor: "pointer",
            }}
          >
            Add Permission
          </button>
        </div>
    </div>
  );
}
